import { unionCityConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function UnionCityPage() {
  return <CityPageTemplate config={unionCityConfig} />;
}